<template>
  <div class="arsenal__tabs">
    <span
      v-for="tab in tabs"
      :key="tab"
      :class="['gtm-filter-availability', { 'type-active': tab === activeTab }]"
      @click="changeTab(tab)"
    >
      {{ $t(`arsenal.tabs.${tab}`) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "ArsenalTabs",

  props: {
    activeTab: String,
  },

  data() {
    return {
      tabs: ["all", "fetched", "no-fetched"],
    };
  },

  methods: {
    changeTab(tab) {
      this.$emit("changeTab", tab);
    },
  },
};
</script>
